/* Copyright 2013 - 2024 Waiterio LLC */
export default 'multilocale'
